import { render, staticRenderFns } from "./FeedbackModal.vue?vue&type=template&id=1d91ae26"
import script from "./FeedbackModal.vue?vue&type=script&lang=js"
export * from "./FeedbackModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports